import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "NEMA_6-15R",
  "use": "NEMA_6-15R-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"NEMA_6-15R\"><path d=\"M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5zm0 1.5C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zM17.5 7.5V11a2.5 2.5 0 105 0V7.5h-5zM16 6h8v5a4 4 0 11-8 0V6zM9.5 23.5v2h6v-2h-6zM8 22h9v5H8v-5zm18.5 1.5v2h6v-2h-6zM25 22h9v5h-9v-5z\" fill=\"#000\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol